import { hojeEmSaoPaulo } from '../../utils/hojeEmSaoPaulo';

/**
 * As datas da janela do risco são dias ("AAAA-MM-DD"), não instantes. O seletor trabalha com a
 * meia-noite local do dia; convertida por UTC, a data escolhida depois das 21h de São Paulo
 * gravaria o dia seguinte, e o 10/01 gravado abriria como 09/01.
 */
export const dataDoDia = (dia: string): Date => {
  const [ano, mes, diaDoMes] = dia.slice(0, 10).split('-').map(Number);
  return new Date(ano, mes - 1, diaDoMes);
};

/** O dia que o seletor mostra, pelos componentes locais da data. */
export const diaDaData = (data: Date): string => {
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dia = String(data.getDate()).padStart(2, '0');
  return `${data.getFullYear()}-${mes}-${dia}`;
};

/** Hoje em São Paulo, como o seletor o mostra. */
export const hojeNoSeletor = (): Date => dataDoDia(hojeEmSaoPaulo());
